<template>
  <container>
    <modal
      v-if="loading"
      no-close
      center-content
    >
      <loader-spinner :size="1.5" />
      <template #footer>
        <span>
          {{ $t('canceling') }} <strong>{{ reservation }}</strong>…<br>
          {{ $t('pleaseWait') }}
        </span>
      </template>
    </modal>

    <header
      v-if="!loading && result"
      class="cart__header"
    >
      <headline>{{ $t(result + '.title') }}</headline>
      <p>{{ $t(result + '.message') }}</p>
    </header>

    <section
      v-if="canBeCancelled && !cancelled"
      class="cart"
    >
      <header class="cart__header">
        <headline level="2">
          {{ $t('confirm') }}
        </headline>
      </header>

      <footer class="cart__footer">
        <action-link
          color="primary"
          @click="cancel"
        >
          {{ $t('yes') }}
        </action-link>
      </footer>
    </section>
  </container>
</template>

<script>
import actionLink from '../components/actionLink.vue'
import container from '../components/container.vue'
import headline from '../components/headline.vue'
import loaderSpinner from '../components/loaderSpinner.vue'
import modal from '../components/modal.vue'

import api from '../api.js'
import eventBus from '../eventBus.js'

export default {
  name: 'VReservationCancelation',

  components: {
    actionLink,
    container,
    headline,
    loaderSpinner,
    modal
  },

  data () {
    return {
      barcode: this.$route.params.barcode,
      loading: true,
      canBeCancelled: false,
      cancelled: false,
      result: ''
    }
  },

  created () {
    this.canCancel()
  },

  methods: {
    canCancel () {
      api.post('reservations/' + this.barcode + '/is_cancelled/').then(response => {
        if (response.data === false) {
          this.canBeCancelled = true
          this.cancelled = false
          this.loading = false
        } else {
          this.canBeCancelled = false
          this.result = 'alreadyCancelled'
          this.loading = false
        }
      }, () => {
        eventBus.emit('handleError')
      })
    },

    cancel () {
      this.cancelled = true
      this.loading = true

      api.post('reservations/' + this.barcode + '/cancel/').then(response => {
        this.loading = false
        this.result = (response.status === 204) ? 'success' : 'error'
        if (this.result === 'success') {
          this.$tracking.eetReservationCancelled(this.barcode)
        }
      })
    }
  }
}
</script>

<i18n locale="en">
{
  "canceling": "Canceling reservation",
  "pleaseWait": "Please wait",
  "confirm": "Are you sure you want to cancel your reservation?",
  "yes": "Yes, I am sure",
  "alreadyCancelled": {
    "title": "Cancelation",
    "message": "Your reservation has already be cancelled."
  },
  "success": {
    "title": "Cancelation confirmed",
    "message": "Your reservation has been canceled."
  },
  "error": {
    "title": "Cancelation failed",
    "message": "The cancelation of your reservation failed."
  }
}
</i18n>

<i18n locale="de">
{
  "canceling": "Storniere Reservierung",
  "pleaseWait": "Bitte warten Sie",
  "confirm": "Wollen Sie Ihre Reservierung wirklich stornieren?",
  "yes": "Ja, ich bin sicher",
  "alreadyCancelled": {
    "title": "Stornierung",
    "message": "Ihre Reservierung wurde bereits storniert."
  },
  "success": {
    "title": "Stornierung bestätigt",
    "message": "Ihre Reservierung wurde storniert."
  },
  "error": {
    "title": "Stornierung fehlgeschlagen",
    "message": "Die Stornierung Ihrer Reservierung ist leider fehlgeschlagen."
  }
}
</i18n>
